/**
 * Geçici marka işareti (SK-07; kalıcı logo ve ikon seti sahibin işi SA-11). "T"nin gövdesi bir onay
 * işaretine döner: mesai kaydı. 32 × 32 ızgarada çizgi olarak çizilir. Aynı tanım hem `Wordmark`
 * bileşenini hem `npm run brand:icons` ile üretilen ikonları besler.
 */
export const MARK_GLYPH = 'M8 9.5H22M15 9.5V19.5L18 22.5L24 15.5';

export const MARK_COLORS = {
  light: { background: '#137C64', glyph: '#FFFFFF' },
  dark: { background: '#0B0F14', glyph: '#45B597' },
} as const;

export type MarkTheme = keyof typeof MARK_COLORS;

export type MarkOptions = {
  size: number;
  theme: MarkTheme;
  /** Köşe yarıçapı 32'lik ızgarada; 0 tam kare (maskable ve apple-touch). */
  radius?: number;
  /** İşaretin ölçeği; maskable ikonda güvenli alan için küçültülür. */
  scale?: number;
};

/** İşaretin tek başına SVG'si (ikon üretimi ve favicon). */
export function markSvg({ size, theme, radius = 8, scale = 1 }: MarkOptions): string {
  const colors = MARK_COLORS[theme];
  return [
    `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 32 32">`,
    `<rect width="32" height="32" rx="${radius}" fill="${colors.background}"/>`,
    `<g transform="translate(16 16) scale(${scale}) translate(-16 -16)">`,
    `<path d="${MARK_GLYPH}" fill="none" stroke="${colors.glyph}" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>`,
    '</g>',
    '</svg>',
  ].join('');
}
